import React, { useEffect, useState } from "react";
import { Button, Input } from "../../../../../BP2Components";
import IntlMessages from "@util/IntlMessages";
import { useDebouncedCallback } from "use-debounce";
import { v4 as uuidv4 } from "uuid";
import PropTypes from "prop-types";
import "./CustomParams.less";

const CustomParams = ({ initialParams = [], setSettings }) => {
   const [params, setParams] = useState([]);

   const handleDelete = (paramId) => (_e) => {
      setParams((prevParams) => {
         const newParams = prevParams.filter((param) => param.id !== paramId);
         setSettings((prevSettings) => ({
            ...prevSettings,
            options: newParams.map((param) => ({
               name: param.name,
               value: param.value,
            })),
         }));

         return newParams;
      });
   };

   const handleAdd = () => {
      setParams((prevParams) => [...prevParams, { name: "", value: "", id: uuidv4() }]);
   };

   const handleInputChange = useDebouncedCallback((paramId, paramType = "name", value) => {
      setParams((prevParams) => {
         const paramToChange = prevParams.find((param) => param.id === paramId);
         const newParams = prevParams;
         newParams[newParams.indexOf(paramToChange)] = {
            ...paramToChange,
            [paramType]: value,
         };

         setSettings((prevSettings) => ({
            ...prevSettings,
            options: newParams.map((param) => ({
               name: param.name,
               value: param.value,
            })),
         }));
         return newParams;
      });
   }, 500);

   useEffect(() => {
      if (initialParams?.length) {
         setParams(
            initialParams.map((param) => {
               param.id = uuidv4();
               return param;
            }),
         );
      }
   }, [initialParams]);

   return (
      <div className="custom-params-container">
         <label>
            <IntlMessages id="settings.customParams" />:
         </label>
         <section className="custom-params">
            <ul className="custom-params__list">
               {params.map((param) => (
                  <li key={param?.id} className="custom-params__list__single">
                     <div className="custom-params__list__single__inputs">
                        <Input
                           className="custom-params__list__single__inputs__single"
                           defaultValue={param.name}
                           placeholder="Name of parameter"
                           onChange={(e) => handleInputChange(param.id, "name", e.target.value)}
                        />
                        <Input
                           defaultValue={param.value}
                           className="custom-params__list__single__inputs__single"
                           placeholder="Value of parameter"
                           onChange={(e) => handleInputChange(param.id, "value", e.target.value)}
                        />
                     </div>
                     <Button
                        htmlType="button"
                        ghost
                        buttonType="danger"
                        onClick={handleDelete(param.id)}
                        className="custom-params__list__single__delete"
                     >
                        <IntlMessages id="global.delete" />
                     </Button>
                  </li>
               ))}
            </ul>
            <Button htmlType="button" onClick={handleAdd} className="custom-params__add">
               <IntlMessages id="global.add" />
            </Button>
         </section>
      </div>
   );
};
CustomParams.propTypes = {
   initialParams: PropTypes.arrayOf(
      PropTypes.shape({
         name: PropTypes.string.isRequired,
         value: PropTypes.string.isRequired,
         id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      }),
   ).isRequired,
   setSettings: PropTypes.func.isRequired,
};

export default CustomParams;
